module.exports = __webpack_public_path__ + "img/golbal_pic.94938d85.jpg";